import React from 'react';
import { Alert } from '@edgebox/react-components';

export function ErrorCard({ error }: { error: unknown }) {
  return (
    <Alert variant="danger" className="mb-3">
      Failed to load: {error instanceof Error ? error.message : String(error)}
    </Alert>
  );
}
